import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-select-sensor-event',
  templateUrl: './select-sensor-event.component.html',
  styleUrls: ['./select-sensor-event.component.less']
})
export class SelectSensorEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-sensors/select-sensor-event/select-sensor-event.component.ts